import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-custom-attribute-icon',
},
  __name: 'custom-attribute-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    "aria-hidden": _ctx.decorative,
    class: "material-design-icon sync-icon",
    role: "img"
  }, [
    (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "enable-background": "new 0 0 24 24",
      viewBox: "0 0 24 24",
      fill: __props.fill
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("g", null, [
        _createElementVNode("rect", {
          fill: "none",
          height: "24",
          width: "24"
        })
      ], -1),
      _createElementVNode("g", null, [
        _createElementVNode("g"),
        _createElementVNode("g", null, [
          _createElementVNode("path", { d: "M22,8l-4-4v3H3v2h15v3L22,8z" }),
          _createElementVNode("path", { d: "M2,16l4,4v-3h15v-2H6v-3L2,16z" })
        ])
      ], -1)
    ]))], 8, _hoisted_2))
  ], 8, _hoisted_1))
}
}

})